<template>
    <div class="row" :class="$q.screen.lt.md ? 'q-col-gutter-md' : 'q-col-gutter-lg'">
        <div class="col-md-6 col-xs-12">
            <WidgetCard
                icon="fak fa-regular fa-qit-ai-assistant-light icon-light-color"
                icon-size-px="28"
                :title="$t('ai-assistant.Ask AI Assistant a question')"
                :description="$t('ai-assistant.Ask a question about this product to AI Assistant')"
            >
                <template #button>
                    <div class="flex justify-end">
                        <QitBtn
                            data-qs="open-ai-assistant"
                            :label="$t('ai-assistant.Open AI Assistant')"
                            color="secondary"
                            @click="goToAIAssistant"
                        />
                    </div>
                </template>
            </WidgetCard>
        </div>
    </div>
</template>

<script setup lang="ts">
import QitBtn from "@/shared/components/buttons/qit-button.vue";
import { CommonRouteAliases } from "@/shared/environment/common-route-aliases.ts";
import { WidgetContext } from "@/shared/environment/widgets/widget-context.ts";
import { useAbilityRoute } from "@/shared/environment/ability-route.ts";
import { router } from "@/app/router.ts";
import WidgetCard from "@/shared/components/widgets/widget-card.vue";

const props = defineProps<{
    widgetContext: WidgetContext;
}>();

const { getPathToChildWithoutParents } = useAbilityRoute();

const goToAIAssistant = () => {
    let product = "",
        asset = "";
    if (props.widgetContext.__type === "asset") {
        asset = props.widgetContext.asset;
        product = props.widgetContext.product;
    } else if (props.widgetContext.__type === "product") {
        product = props.widgetContext.productId;
    }

    const pathToChild = getPathToChildWithoutParents(CommonRouteAliases.aiAssistant, {
        ["product"]: product,
        ["asset"]: asset,
    });

    router.push(pathToChild);
};
</script>
